import { forwardRef } from 'react';
import { WeaveTheme } from '@frontend/theme';

export interface WeaveUpgradeProps extends React.SVGProps<SVGSVGElement> {
  colors: WeaveTheme['colors'];
  primaryColor?: string;
  secondaryColor?: string;
}

const WeaveUpgrade = forwardRef<SVGSVGElement, WeaveUpgradeProps>(
  ({ colors, primaryColor, secondaryColor, ...props }, ref) => {
    return (
      <svg {...props} ref={ref} fill='none' viewBox='0 0 50 65'>
        <g filter='url(#a)'>
          <mask id='b' width='20' height='24' x='15' y='26' maskUnits='userSpaceOnUse' style={{ maskType: 'alpha' }}>
            <path
              fill={primaryColor ?? colors.secondary.seaweed50}
              d='m15.455 49.636.636-23.545h17.818l.636 23.545L25 45.182z'
            ></path>
          </mask>
          <g mask='url(#b)'>
            <path
              fill={secondaryColor ?? colors.secondary.seaweed40}
              d='m15.455 49.636.636-23.545h17.818l.636 23.545L25 45.182z'
            ></path>
            <path fill='#3EBFB8' d='m32.183 27.864.511 18.952L25 43.226l-7.694 3.59.511-18.953h14.366'></path>
            <g filter='url(#c)' style={{ mixBlendMode: 'overlay' }}>
              <path fill='url(#d)' d='M12.273 28.636h25.454v22.909H12.273z'></path>
            </g>
            <g filter='url(#e)' opacity='.4' style={{ mixBlendMode: 'multiply' }}>
              <path
                fill='black'
                d='M44.091 18.454c0 10.544-8.547 19.091-19.09 19.091-10.545 0-19.092-8.547-19.092-19.09C5.91 7.91 14.457-.637 25-.637c10.544 0 19.091 8.547 19.091 19.09'
              ></path>
            </g>
          </g>
          <path
            fill={secondaryColor ?? colors.secondary.seaweed40}
            d='M39 21c0 7.732-6.268 14-14 14s-14-6.268-14-14S17.268 7 25 7s14 6.268 14 14'
          ></path>
          <path
            fill='url(#f)'
            d='M39 21c0 7.732-6.268 14-14 14s-14-6.268-14-14S17.268 7 25 7s14 6.268 14 14'
            style={{ mixBlendMode: 'multiply' }}
          ></path>
          <circle cx='25' cy='21' r='9.545' fill='#4CDCD3'></circle>
          <path
            fill='black'
            fillOpacity='.75'
            fillRule='evenodd'
            d='M24.15 20.047v1.855c-.002 1.99 1.646 3.619 3.716 3.674 1.957-.002 3.59-1.44 3.762-3.314.03-.276.041-.983.041-1.26 0-.279-.01-.986-.04-1.262-.112-1.31-.954-2.46-2.2-3.002a3.895 3.895 0 0 0-3.8.39.094.094 0 0 0 0 .121l.79 1.26c.012.017.032.03.055.032a.08.08 0 0 0 .062-.02 2.14 2.14 0 0 1 2.074-.341 2.01 2.01 0 0 1 1.316 1.577c.042.41.06.823.054 1.236.006.409-.012.817-.054 1.224-.143.985-1.019 1.719-2.054 1.72a2.05 2.05 0 0 1-1.424-.597 1.957 1.957 0 0 1-.587-1.395v-1.854c0-1.993-1.653-3.623-3.727-3.672-1.96.002-3.593 1.444-3.762 3.321-.03.274-.041.981-.041 1.26 0 .277 0 .984.04 1.26.112 1.312.956 2.461 2.203 3.003a3.894 3.894 0 0 0 3.801-.394.094.094 0 0 0 0-.122l-.79-1.259a.08.08 0 0 0-.118-.012 2.14 2.14 0 0 1-2.073.34 2.01 2.01 0 0 1-1.316-1.576 10.87 10.87 0 0 1-.051-1.237c-.008-.408.01-.817.051-1.224.143-.985 1.02-1.718 2.054-1.72a2.05 2.05 0 0 1 1.424.598c.378.373.588.874.587 1.395l.007-.005'
            clipRule='evenodd'
            style={{ mixBlendMode: 'hard-light' }}
          ></path>
          <circle cx='25' cy='21' r='9.545' fill='url(#g)' fillOpacity='.51'></circle>
        </g>
        <defs>
          <filter
            id='a'
            width='50'
            height='64.636'
            x='0'
            y='0'
            colorInterpolationFilters='sRGB'
            filterUnits='userSpaceOnUse'
          >
            <feFlood floodOpacity='0' result='BackgroundImageFix'></feFlood>
            <feColorMatrix
              in='SourceAlpha'
              result='hardAlpha'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            ></feColorMatrix>
            <feMorphology
              in='SourceAlpha'
              operator='dilate'
              radius='3'
              result='effect1_dropShadow_39251_18703'
            ></feMorphology>
            <feOffset dy='4'></feOffset>
            <feGaussianBlur stdDeviation='4'></feGaussianBlur>
            <feComposite in2='hardAlpha' operator='out'></feComposite>
            <feColorMatrix values='0 0 0 0 0.117647 0 0 0 0 0.196078 0 0 0 0 0.317647 0 0 0 0.15 0'></feColorMatrix>
            <feBlend in2='BackgroundImageFix' result='effect1_dropShadow_39251_18703'></feBlend>
            <feColorMatrix
              in='SourceAlpha'
              result='hardAlpha'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            ></feColorMatrix>
            <feOffset dy='1'></feOffset>
            <feGaussianBlur stdDeviation='1.5'></feGaussianBlur>
            <feColorMatrix values='0 0 0 0 0.117647 0 0 0 0 0.196078 0 0 0 0 0.317647 0 0 0 0.15 0'></feColorMatrix>
            <feBlend in2='effect1_dropShadow_39251_18703' result='effect2_dropShadow_39251_18703'></feBlend>
            <feBlend in='SourceGraphic' in2='effect2_dropShadow_39251_18703' result='shape'></feBlend>
          </filter>
          <filter
            id='c'
            width='34.455'
            height='31.909'
            x='7.773'
            y='24.136'
            colorInterpolationFilters='sRGB'
            filterUnits='userSpaceOnUse'
          >
            <feFlood floodOpacity='0' result='BackgroundImageFix'></feFlood>
            <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape'></feBlend>
            <feTurbulence
              baseFrequency='0.99900001287460327 0.99900001287460327'
              numOctaves='3'
              seed='958'
              type='fractalNoise'
            ></feTurbulence>
            <feDisplacementMap
              width='100%'
              height='100%'
              in='shape'
              result='displacedImage'
              scale='9'
              xChannelSelector='R'
              yChannelSelector='G'
            ></feDisplacementMap>
            <feMerge result='effect1_texture_39251_18703'>
              <feMergeNode in='displacedImage'></feMergeNode>
            </feMerge>
          </filter>
          <filter
            id='e'
            width='54.727'
            height='54.727'
            x='-2.364'
            y='-8.909'
            colorInterpolationFilters='sRGB'
            filterUnits='userSpaceOnUse'
          >
            <feFlood floodOpacity='0' result='BackgroundImageFix'></feFlood>
            <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape'></feBlend>
            <feGaussianBlur result='effect1_foregroundBlur_39251_18703' stdDeviation='4.136'></feGaussianBlur>
          </filter>
          <radialGradient
            id='f'
            cx='0'
            cy='0'
            r='1'
            gradientTransform='rotate(120.069 6.446 17.707)scale(13.971)'
            gradientUnits='userSpaceOnUse'
          >
            <stop offset='.737' stopColor='#D9D9D9'></stop>
            <stop offset='.888' stopColor='white'></stop>
            <stop offset='1' stopColor='#E5E5E5'></stop>
          </radialGradient>
          <radialGradient
            id='g'
            cx='0'
            cy='0'
            r='1'
            gradientTransform='rotate(123.024 8.317 16.39)scale(12.6497)'
            gradientUnits='userSpaceOnUse'
          >
            <stop stopColor='#DFDFDF'></stop>
            <stop offset='.466' stopColor='#B3B3B3'></stop>
            <stop offset='1' stopColor='#7F7F7F'></stop>
          </radialGradient>
          <linearGradient id='d' x1='25' x2='25' y1='28.636' y2='51.545' gradientUnits='userSpaceOnUse'>
            <stop stopColor='#EEEEEE'></stop>
            <stop offset='1' stopColor='#5C5C5C'></stop>
          </linearGradient>
        </defs>
      </svg>
    );
  }
);

WeaveUpgrade.displayName = 'WeaveUpgrade';

export default WeaveUpgrade;
